import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import postDetails from './data-blog.json';
import { Parallax } from "react-parallax";
import { AppContext } from '../main';



const postsPerPage = 6; // Number of posts per page

const Section = (props) => {
  const {
    handleEditItem
  } = props
  const navigate = useNavigate();

  const { appState
  } = useContext(AppContext);
  const { blogsnotitle = {
    blogs: [
      {
        "id": 1,
        "image": "./img/news/1.webp",
        "date": "25.10.2023",
        "title": "How to Set Up Your Own Game Server",
        "excerpt": "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat..."
      },
      {
        "id": 2,
        "image": "./img/news/2.webp",
        "date": "25.10.2023",
        "title": "Rise in Demand for Private Game Servers",
        "excerpt": "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat..."
      },
      {
        "id": 3,
        "image": "./img/news/3.webp",
        "date": "25.10.2023",
        "title": "Top Hosting Providers for Game Servers",
        "excerpt": "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat..."
      },
      {
        "id": 4,
        "image": "./img/news/4.webp",
        "date": "25.10.2023",
        "title": "E-Sports and Competitive Gaming",
        "excerpt": "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat..."
      },
      {
        "id": 5,
        "image": "./img/news/5.webp",
        "date": "25.10.2023",
        "title": "How to Protect Your Online World",
        "excerpt": "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat..."
      },
      {
        "id": 6,
        "image": "./img/news/6.webp",
        "date": "25.10.2023",
        "title": "5 Ways to Maintain a Good Posture",
        "excerpt": "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat..."
      }]
  }
    , editMode = false
  } = appState


  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;


  const totalPages = Math.ceil(postDetails.length / postsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  if (!(blogsnotitle?.blogs)) {
    return null
  }


  return (
    <div className="container">
      <div className="row g-4">
        {blogsnotitle?.blogs?.map((post) => (
          <div key={post.id} className="col-lg-4 col-md-6 mb10">
            <div className="bloglist item">
              <div className="post-content">
                <div className="post-image">
                  {post?.secondTag && <div className="d-tagline">
                    <span onClick={() => {
                      if (post?.firstTagLink?.includes('http')) {
                        window.open(post?.firstTagLink, '_self');
                      } else if (post?.firstTagLink) {
                        navigate(post?.firstTagLink);
                      }

                    }}>{post?.firstTag}</span>
                    <span onClick={() => {
                      if (post?.secondTagLink?.includes('http')) {
                        window.open(post?.secondTagLink, '_self');
                      } else if (post?.secondTagLink) {
                        navigate(post?.secondTagLink);
                      }
                    }}>{post?.secondTag}</span>
                  </div>}
                  <img src={post.image} alt="" />
                </div>
                <div className="post-text">
                  <div className="d-date">{post.date}</div>
                  <h4>
                    <Link to="/">{post.title}<span></span></Link>
                  </h4>
                  <p>{post.excerpt}</p>
                </div>
              </div>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default Section;
